<template>
  <refonte-button
    variant="secondary"
    v-bind:on_click="props.cancel">
    Annuler
  </refonte-button>
  <refonte-button
    v-bind:disabled="props.submit_disabled || buttonDisabled"
    v-bind:on_click="onSubmit">
    Lancer la procédure
  </refonte-button>
</template>

<script setup lang="ts">
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import { ref } from 'vue';

  const props = withDefaults(
    defineProps<{
      cancel?: Function;
      submit?: Function;
      submit_disabled?: boolean;
      class?: string;
    }>(),
    {
      class: ''
    }
  );
  const buttonDisabled = ref<boolean>(false);
  const onSubmit = () => {
    buttonDisabled.value = true;
    if (props.submit) {
      props.submit();
    }
  };
</script>

<style lang="scss" scoped></style>
